import React, { useEffect, useMemo, useState } from "react";

type TrackedItem = {
  type: "error" | "rejection";
  message: string;
  stack?: string;
  timestamp: number;
};

function useTrackedErrors() {
  const [items, setItems] = useState<TrackedItem[]>(() => (window as any).__assetChainConsoleErrors__?.slice?.() || []);

  useEffect(() => {
    const id = window.setInterval(() => {
      const current = (window as any).__assetChainConsoleErrors__?.slice?.() || [];
      setItems(current);
    }, 1000);
    return () => window.clearInterval(id);
  }, []);

  return items;
}

export default function ConsoleErrors() {
  const items = useTrackedErrors();
  const [filter, setFilter] = useState<"all" | "error" | "rejection">("all");

  const filtered = useMemo(() => {
    return items
      .filter((i) => (filter === "all" ? true : i.type === filter))
      .slice(-100)
      .reverse();
  }, [items, filter]);

  const clear = () => {
    (window as any).__assetChainConsoleErrors__ = [];
  };

  return (
    <div style={{ padding: 24, maxWidth: 1000, margin: "0 auto", fontFamily: "monospace" }}>
      <h2>Recent Console Errors (dev)</h2>
      <div style={{ display: "flex", gap: 12, alignItems: "center", marginBottom: 12 }}>
        <label>
          Filter:
          <select value={filter} onChange={(e) => setFilter(e.target.value as any)} style={{ marginLeft: 8 }}>
            <option value="all">all</option>
            <option value="error">error</option>
            <option value="rejection">rejection</option>
          </select>
        </label>
        <button onClick={clear} style={{ padding: "4px 8px" }}>
          Clear
        </button>
        <span>Count: {items.length}</span>
      </div>
      {filtered.length === 0 ? (
        <div>No tracked errors yet.</div>
      ) : (
        <ul style={{ listStyle: "none", padding: 0 }}>
          {filtered.map((i, idx) => (
            <li key={idx} style={{ border: "1px solid #ddd", padding: 12, marginBottom: 12 }}>
              <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 6 }}>
                <strong>[{i.type}]</strong>
                <span>{new Date(i.timestamp).toLocaleString()}</span>
              </div>
              <div style={{ whiteSpace: "pre-wrap" }}>{i.message}</div>
              {i.stack && (
                <details style={{ marginTop: 8 }}>
                  <summary>stack</summary>
                  <pre style={{ whiteSpace: "pre-wrap" }}>{i.stack}</pre>
                </details>
              )}
            </li>
          ))}
        </ul>
      )}
      <div style={{ marginTop: 16, fontSize: 12, opacity: 0.8 }}>
        Tip: In DevTools console you can view raw data with
        <code> window.__assetChainConsoleErrors__ </code>
      </div>
    </div>
  );
}
